import React from 'react';

import SaleBaseCozyGame from './SaleBaseCozyGame';
function AuctionHouseCozyGame() {
  return <SaleBaseCozyGame saleType="Auction" />;
}

export default AuctionHouseCozyGame;